// extracted by mini-css-extract-plugin
module.exports = {"title":"ModuleItemsRemoveConfirmationDialogTheme_title__o9F5x","dialog":"ModuleItemsRemoveConfirmationDialogTheme_dialog__ZceSp"};